import { Component } from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterOutlet} from '@angular/router';
import {HomeFooter} from '../../features/user-home/home-footer/home-footer.component';
import {HomeHeader} from '../../features/user-home/home-header/home-header.component';

@Component({
  selector: 'app-website-layout',
  imports: [CommonModule, RouterOutlet, HomeFooter, HomeHeader],
  templateUrl: './website-layout.component.html',
  styleUrl: './website-layout.component.scss',
})
export class WebsiteLayoutComponent {

}
